import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const QuestionnaireTabs = () => {
  const location = useLocation();
  return (
    <>
      <ul
        className="nav d-flex flex-wrap justify-content-between mb-5 position-relative"
        id="step-tab"
        role="tablist"
      >
        <li className="nav-item">
          <Link
            to=""
            className="complete fs-3 p-0 d-flex flex-wrap justify-content-center align-items-center align-content-center position-relative rounded-pill"
          >
            <span className="num lh-1">1</span>
            <span className="value fs-6 text-muted p-0 mt-2 position-absolute top-100 start-50 translate-middle-x">
              Record <br />
              Request
            </span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to=""
            className={
              "fs-3 p-0 d-flex flex-wrap justify-content-center align-items-center align-content-center position-relative rounded-pill " +
              (location.pathname === "/questionnaire-intake-form" ||
              location.pathname === "/questionnaire-review-submit" ||
              location.pathname === "/questionnaire-billing-info"
                ? "complete    active"
                : " ")
            }
          >
            <span className="num lh-1">2</span>
            <span className="value fs-6 text-muted p-0 mt-2 position-absolute top-100 start-50 translate-middle-x">
              Intake <br />
              Form
            </span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to=""
            className={
              "complete111 fs-3 p-0 d-flex flex-wrap justify-content-center align-items-center align-content-center position-relative rounded-pill " +
              (location.pathname === "/questionnaire-review-submit" ||
              location.pathname === "/questionnaire-billing-info"
                ? "complete    active"
                : " ")
            }
          >
            <span className="num lh-1">3</span>
            <span className="value fs-6 text-muted p-0 mt-2 position-absolute top-100 start-50 translate-middle-x">
              Review and <br />
              Submit
            </span>
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to=""
            className={
              "complete111 fs-3 p-0 d-flex flex-wrap justify-content-center align-items-center align-content-center position-relative rounded-pill " +
              (location.pathname === "/questionnaire-billing-info"
                ? "complete    active"
                : " ")
            }
          >
            <span className="num lh-1">4</span>
            <span className="value fs-6 text-muted p-0 mt-2 position-absolute top-100 start-50 translate-middle-x">
              Billing <br />
              Information
            </span>
          </Link>
        </li>
      </ul>
    </>
  );
};

export default QuestionnaireTabs;
